module.exports = __webpack_public_path__ + "static/media/step5.6c430f57.png";